import React from "react";

export class LoanNumberPromptHeader extends React.Component {
    render() {
        return <h3>Enter your loan number to get started:</h3>;
    }
}